export default {"src":"/_next/static/media/organize.7cb0d8cf.svg","height":65,"width":55};